import { useCallback, useRef } from 'react';
import { useAtom, useSetAtom } from 'jotai';
import { getChatUpdatesUseCase } from '../use-cases/get-chat-updates.use-case';
import { selectedChatAtom } from '../states/selected-chat';
import { chatListSetter } from '../states/chat';
import { CHAT_UPDATE_TYPE } from '../typings/chat';

export const useChatUpdates = () => {
  const [selectedChat, setSelectedChat] = useAtom(selectedChatAtom);
  const setChatList = useSetAtom(chatListSetter);

  const setChatListRef = useRef(setChatList);
  const selectedChatRef = useRef(selectedChat);
  const setSelectedChatRef = useRef(setSelectedChat);

  setChatListRef.current = setChatList;
  selectedChatRef.current = selectedChat;
  setSelectedChatRef.current = setSelectedChat;

  const MAX_RETRIES = 6;

  const fetchAndUpdateChats = useCallback(
    async (lastUpdateTimestamp: number, retryCount = 0) => {
      const timeWhenAPIWasCalled = Date.now() - 2 * 60 * 1000; // API response time max 2 minutes
      const updates = await getChatUpdatesUseCase(lastUpdateTimestamp);

      if (!updates) {
        return;
      }

      setChatListRef.current({
        type: CHAT_UPDATE_TYPE.API_UPDATES,
        updates,
      });

      // Check if the tillTimestamp is less than or equal to the time when the API was called
      if (updates.tillTimestamp <= timeWhenAPIWasCalled) {
        // If retry count is less than the maximum allowed retries, recursively call the function
        if (retryCount < MAX_RETRIES) {
          await fetchAndUpdateChats(updates.tillTimestamp, retryCount + 1);
        } else {
          // Reload the page after 6 attempts
          window.location.reload();
        }
      }
    },
    []
  );

  return { updateChats: fetchAndUpdateChats };
};
